import { useToast, TYPE as ToastType } from 'vue-toastification'
import UiToast from '@/components/shared/UiToast.vue'
import type { ToastOptions } from 'vue-toastification/dist/types/types'

export { TYPE as ToastTypes } from 'vue-toastification'

type ToastContent = Parameters<ReturnType<typeof useToast>>[0]

export function toast(request: {
  message: string
  details?: string
  icon?: ToastType
  onClick?: () => void
  component?: ToastContent
  options?: ToastOptions
}) {
  const toastFn = useToast()
  const icon = request.icon ?? ToastType.INFO
  const { onClick = () => {}, ...props } = request
  return toastFn(
    {
      component: request.component ?? UiToast,
      props: {
        ...props,
        icon
      },
      listeners: {
        click: onClick
      }
    },
    {
      type: icon,
      ...request.options,
    }
  )
}
